// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "imports.proto" (package "imports", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ImportService } from "./imports";
import type { GetKnownFingerprintsResponse } from "./imports";
import type { GetKnownFingerprintsRequest } from "./imports";
import type { SaveImportProfileResponse } from "./imports";
import type { SaveImportProfileRequest } from "./imports";
import type { GetAllImportProfilesResponse } from "./imports";
import type { GetAllImportProfilesRequest } from "./imports";
import type { DeleteImportResponse } from "./imports";
import type { DeleteImportRequest } from "./imports";
import type { GetAllImportsResponse } from "./imports";
import type { GetAllImportsRequest } from "./imports";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { StartImportResponse } from "./imports";
import type { StartImportRequest } from "./imports";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service imports.ImportService
 */
export interface IImportServiceClient {
    /**
     * @generated from protobuf rpc: StartImport
     */
    startImport(input: StartImportRequest, options?: RpcOptions): UnaryCall<StartImportRequest, StartImportResponse>;
    /**
     * @generated from protobuf rpc: GetAllImports
     */
    getAllImports(input: GetAllImportsRequest, options?: RpcOptions): UnaryCall<GetAllImportsRequest, GetAllImportsResponse>;
    /**
     * @generated from protobuf rpc: DeleteImport
     */
    deleteImport(input: DeleteImportRequest, options?: RpcOptions): UnaryCall<DeleteImportRequest, DeleteImportResponse>;
    /**
     * @generated from protobuf rpc: GetAllImportProfiles
     */
    getAllImportProfiles(input: GetAllImportProfilesRequest, options?: RpcOptions): UnaryCall<GetAllImportProfilesRequest, GetAllImportProfilesResponse>;
    /**
     * @generated from protobuf rpc: SaveImportProfile
     */
    saveImportProfile(input: SaveImportProfileRequest, options?: RpcOptions): UnaryCall<SaveImportProfileRequest, SaveImportProfileResponse>;
    /**
     * @generated from protobuf rpc: GetKnownFingerprints
     */
    getKnownFingerprints(input: GetKnownFingerprintsRequest, options?: RpcOptions): UnaryCall<GetKnownFingerprintsRequest, GetKnownFingerprintsResponse>;
}
/**
 * @generated from protobuf service imports.ImportService
 */
export class ImportServiceClient implements IImportServiceClient, ServiceInfo {
    typeName = ImportService.typeName;
    methods = ImportService.methods;
    options = ImportService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: StartImport
     */
    startImport(input: StartImportRequest, options?: RpcOptions): UnaryCall<StartImportRequest, StartImportResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartImportRequest, StartImportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAllImports
     */
    getAllImports(input: GetAllImportsRequest, options?: RpcOptions): UnaryCall<GetAllImportsRequest, GetAllImportsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllImportsRequest, GetAllImportsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteImport
     */
    deleteImport(input: DeleteImportRequest, options?: RpcOptions): UnaryCall<DeleteImportRequest, DeleteImportResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteImportRequest, DeleteImportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAllImportProfiles
     */
    getAllImportProfiles(input: GetAllImportProfilesRequest, options?: RpcOptions): UnaryCall<GetAllImportProfilesRequest, GetAllImportProfilesResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllImportProfilesRequest, GetAllImportProfilesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SaveImportProfile
     */
    saveImportProfile(input: SaveImportProfileRequest, options?: RpcOptions): UnaryCall<SaveImportProfileRequest, SaveImportProfileResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SaveImportProfileRequest, SaveImportProfileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetKnownFingerprints
     */
    getKnownFingerprints(input: GetKnownFingerprintsRequest, options?: RpcOptions): UnaryCall<GetKnownFingerprintsRequest, GetKnownFingerprintsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetKnownFingerprintsRequest, GetKnownFingerprintsResponse>("unary", this._transport, method, opt, input);
    }
}
